import { Component, OnInit, Input } from '@angular/core';
import { PipeMaterialGroupModel } from '../../../../models/dictionaries/pipe-material-group.model';
import { MainPageService } from '../../../../main-page/main-page.service';
import { PipeMaterialManagmentComponent } from '../../../../main-page/dictionaries/pipe-material/pipe-material-managment/pipe-material-managment.component';


declare var $: any;

@Component({
  selector: 'app-pipe-materials-grid',
  template: `<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipe material group?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deletePipeMaterial()">Delete</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!isPipeMaterialChoosen">
    <div class="input-effect">
        <input class="effect1" type="text" placeholder="">
        <label>Search</label>
        <span class="focus-border"></span>
    </div>
    <button class="red-button" type="button" data-toggle="modal" data-target="#addModal" (click)="createNewPipeMaterial()">Create</button>

    <table>
        <tr>
            <th *ngFor="let header of headers">{{header}}</th>
        </tr>
        <tr *ngFor="let pipeMaterial of pipeMaterialsGridData, let row_no = index">
            <td>{{pipeMaterial.name}}</td>
            <td>{{pipeMaterial.description}}</td>
            <td class="columnWithIcons">
                <button type="button" class="btn editBtn" (click)="editPipeMaterial(pipeMaterial)">
                    <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(pipeMaterial)">
                    <i class="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    </table>
</div>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class PipeMaterialsGridComponent implements OnInit {
  @Input() managmentComponent: PipeMaterialManagmentComponent;
  isPipeGroupsHidden = true;
  pipeMaterialsGridData: PipeMaterialGroupModel[];
  selectedPipeMaterial: PipeMaterialGroupModel;
  isPipeMaterialChoosen: boolean = false;
  elementIndex: number;
  headers: string[] = ['Name', 'Description', ''];

  constructor(private mainPageService: MainPageService) { }

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deletePipeMaterialSubject.subscribe((value) => {
      this.pipeMaterialsGridData = this.pipeMaterialsGridData.filter(x => x._id !== value);
    });
    this.managmentComponent.stateSubject.subscribe((state) => {
      if (state !== null) {
        Object.assign(this.pipeMaterialsGridData[this.elementIndex], state);
      }
      this.isPipeMaterialChoosen = false;
    });
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllPipeMaterials().subscribe((response) => {
      this.pipeMaterialsGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
      $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isPipeGroupsHidden = !this.isPipeGroupsHidden;
  }

  createNewPipeMaterial() {
    const pipeMaterial = new PipeMaterialGroupModel();
    this.mainPageService.addNewPipeMaterialIntoDb(JSON.stringify(pipeMaterial)).subscribe((response) => {
      pipeMaterial._id = response._id;
      pipeMaterial.id = response.id;
      this.pipeMaterialsGridData.push(pipeMaterial);
      this.elementIndex = this.pipeMaterialsGridData.indexOf(pipeMaterial);
      this.managmentComponent.showManagmentPage(pipeMaterial, true);
    });
    this.isPipeMaterialChoosen = true;
  }

  setChoosenElement(element) {
    this.selectedPipeMaterial = {
      ...element,
    };
    this.elementIndex = this.pipeMaterialsGridData.indexOf(element);
  };

  editPipeMaterial(element) {
    this.selectedPipeMaterial = {
      ...element,
    };
    this.elementIndex = this.pipeMaterialsGridData.indexOf(element);
    this.managmentComponent.showManagmentPage(this.selectedPipeMaterial);
    this.isPipeMaterialChoosen = true;
  }

  deletePipeMaterial() {
    this.mainPageService.removePipeMaterial(this.selectedPipeMaterial._id).subscribe(() => { }, () => { });
    this.mainPageService.deletePipeMaterialSubject.next(this.selectedPipeMaterial._id);
  }
}
